// removed by extract-text-webpack-plugin
module.exports = {"card":"styles__card___1xNY7","icon":"styles__icon___1_-9p"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/Card/styles.css
// module id = 1205
// module chunks = 0